var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"c-btn c-btn--tiny c-btn--secondary no-margin",attrs:{"to":{ name: _vm.route, params: { id: _vm.value } }}},[_vm._v("Bekijken")])}
var staticRenderFns = []

export { render, staticRenderFns }